<div class="exit-main">
    <p class="exit-title">Por favor registra tu salida</p>
    <button type="button" class="exit-button" mat-raised-button (click)="onClick()">Registrar</button>
</div>